import { downloadCSVFile } from '@xto10x/core/lib/app.utils';
import { Parser } from '@json2csv/plainjs';
import moment from 'moment';
import {
  exportCsvHeaders,
  OBJECTIVE_VISIBILITY_TYPES,
  ManagerApprovalTypes
} from 'utils/constants';

export const getFlatObjective = objective => {
  const tempObjectiveArray = [];
  tempObjectiveArray.push({ ...objective });
  // is open to check if show alignment button clicked
  if (
    objective.key_results &&
    objective.key_results.length > 0 &&
    (objective.isOpen || objective.alignment_of)
  ) {
    for (let i = 0; i < objective.key_results.length; i += 1) {
      tempObjectiveArray.push(
        ...getFlatObjective({
          ...objective.key_results[i],
          parent_objective_id: objective.objective_id
        })
      );
    }
  }
  return tempObjectiveArray;
};

export const getCompanyLabel = (isRoot, isCompany, isCompanyChain) => {
  if (isRoot && isCompany) {
    return 'Company';
  }
  if (isRoot && !isCompany) {
    return 'Independent';
  }
  if (!isRoot && isCompanyChain) {
    return 'Company';
  }
  if (!isRoot && !isCompanyChain) {
    return 'Independent';
  }
  return null;
};

export const getObjectiveTitle = (objectiveId, objectiveArray) => {
  for (let i = 0; i < objectiveArray.length; i += 1) {
    if (objectiveArray[i].objective_id === objectiveId)
      return objectiveArray[i].title;
  }
  return null;
};

const restrictedObjective = {
  [exportCsvHeaders.IS_ALIGNED_TO]: 'N.A.',
  [exportCsvHeaders.TITLE]:
    'This objective isn’t visible to you. Please change the visibility filters or reach out to the owner of objectives to view this',
  [exportCsvHeaders.PARENT_OBJECTIVE_TITLE]: 'N.A.',
  [exportCsvHeaders.STATE]: 'N.A.',
  [exportCsvHeaders.START_DATE]: 'N.A.',
  [exportCsvHeaders.DUE_DATE]: 'N.A.',
  [exportCsvHeaders.OWNER]: 'N.A.',
  [exportCsvHeaders.OWNER_EMAIL]: 'N.A.',
  [exportCsvHeaders.TEAMS]: 'N.A.',
  [exportCsvHeaders.TAGS]: 'N.A.',
  [exportCsvHeaders.METRIC_NAME]: 'N.A.',
  [exportCsvHeaders.START_VALUE]: 'N.A.',
  [exportCsvHeaders.TARGET_VALUE]: 'N.A.',
  [exportCsvHeaders.CURRENT_VALUE]: 'N.A.',
  [exportCsvHeaders.MILESTONE_1_DATE]: 'N.A.',
  [exportCsvHeaders.MILESTONE_1_VALUE]: 'N.A.',
  [exportCsvHeaders.MILESTONE_2_DATE]: 'N.A.',
  [exportCsvHeaders.MILESTONE_2_VALUE]: 'N.A.',
  [exportCsvHeaders.PROGRESS]: 'N.A.',
  [exportCsvHeaders.STATUS]: 'N.A.',
  [exportCsvHeaders.LAST_UPDATED_TIME]: 'N.A.',
  [exportCsvHeaders.LAST_CHECK_IN]: 'N.A.',
  [exportCsvHeaders.MANAGER_APPROVAL_STATUS]: 'N.A.'
};

export const returnObjective = (objective, flatObjectiveArray) => {
  const teams = [];
  const objectiveTags = [];
  if (objective) {
    const { tags, objective_tags } = objective;
    // eslint-disable-next-line no-unused-expressions
    tags &&
      tags.forEach(element => {
        teams.push(element.label);
      });

    if (objective_tags)
      objective_tags.forEach(element => {
        objectiveTags.push(element.label);
      });

    const lastUpdatedAt = objective.attributes
      ? moment(objective.attributes.last_check_in_time).format(
          'DD-MM-YYYY hh:mm:a'
        )
      : null;

    let milestones = {};
    const milestoneKeys =
      objective.metric && objective.metric.attributes?.mile_stones
        ? Object.keys(objective.metric.attributes?.mile_stones)
        : null;
    if (milestoneKeys) {
      milestoneKeys.forEach((key, index) => {
        milestones = {
          ...milestones,
          [exportCsvHeaders.MILESTONE_DATE.replace(/\$value\$/g, index + 1)]:
            key || '',
          [exportCsvHeaders.MILESTONE_VALUE.replace(/\$value\$/g, index + 1)]:
            objective.metric.attributes?.mile_stones[key] || ''
        };
      });
    }
    const temp = {
      [exportCsvHeaders.IS_ALIGNED_TO]: getCompanyLabel(
        objective.root_objective,
        objective.company_objective,
        objective.company_objective_chain
      ),
      [exportCsvHeaders.TITLE]: objective.title,
      [exportCsvHeaders.PARENT_OBJECTIVE_TITLE]: getObjectiveTitle(
        objective.parent_objective_id,
        flatObjectiveArray
      ),
      [exportCsvHeaders.STATE]: objective.status,
      [exportCsvHeaders.START_DATE]: objective.start_date,
      [exportCsvHeaders.DUE_DATE]: objective.due_date,
      [exportCsvHeaders.OWNER]:
        objective.owner_detail && objective.owner_detail.name,
      [exportCsvHeaders.OWNER_EMAIL]:
        objective.owner_detail && objective.owner_detail?.email,
      [exportCsvHeaders.TEAMS]: teams.toString(),
      [exportCsvHeaders.TAGS]: objectiveTags.toString(),
      [exportCsvHeaders.METRIC_NAME]: objective.metric
        ? objective.metric.name
        : '',
      [exportCsvHeaders.START_VALUE]: objective.metric
        ? objective.metric.start_value
        : '',
      [exportCsvHeaders.TARGET_VALUE]: objective.metric
        ? objective.metric.target_value
        : '',
      [exportCsvHeaders.CURRENT_VALUE]: objective.metric
        ? objective.metric?.current_value
        : '',
      ...milestones,
      [exportCsvHeaders.PROGRESS]: objective.progress,
      [exportCsvHeaders.STATUS]: objective.objective_completion_status,
      [exportCsvHeaders.LAST_UPDATED_TIME]: lastUpdatedAt,
      [exportCsvHeaders.LAST_CHECK_IN]: objective.attributes
        ? objective.attributes.latest_check_in
        : null,
      [exportCsvHeaders.MANAGER_APPROVAL_STATUS]: objective
        .manager_approval_details?.manager_approval_status
        ? ManagerApprovalTypes[
            objective.manager_approval_details.manager_approval_status
          ]
        : 'N.A.',
      [exportCsvHeaders.OBJECTIVE_ID]: objective.objective_id
    };
    return temp;
  }
  return null;
};

const getIsRestrictedView = (
  { privacy_details, visible },
  { showProtectedObjectives, showCustomObjectives }
) =>
  !visible ||
  (!showProtectedObjectives &&
    privacy_details &&
    [
      OBJECTIVE_VISIBILITY_TYPES.protectedWithoutContributors,
      OBJECTIVE_VISIBILITY_TYPES.protectedWithContributors
    ].indexOf(privacy_details.type) !== -1) ||
  (!showCustomObjectives &&
    privacy_details &&
    privacy_details.type === OBJECTIVE_VISIBILITY_TYPES.custom);

const exportObjective = (objective, filename, visibilitySettings = null) => {
  // eslint-disable-next-line prefer-const
  let flatObjectiveArray = [];
  const resultArray = [];
  const csvHeaders = [
    exportCsvHeaders.IS_ALIGNED_TO,
    exportCsvHeaders.TITLE,
    exportCsvHeaders.PARENT_OBJECTIVE_TITLE,
    exportCsvHeaders.METRIC,
    exportCsvHeaders.STATE,
    exportCsvHeaders.START_DATE,
    exportCsvHeaders.DUE_DATE,
    exportCsvHeaders.OWNER,
    exportCsvHeaders.OWNER_EMAIL,
    exportCsvHeaders.TEAMS,
    exportCsvHeaders.TAGS,
    exportCsvHeaders.PROGRESS,
    exportCsvHeaders.STATUS,
    exportCsvHeaders.LAST_CHECK_IN,
    exportCsvHeaders.LAST_UPDATED_AT,
    exportCsvHeaders.MANAGER_APPROVAL_STATUS,
    exportCsvHeaders.OBJECTIVE_ID
  ];
  // putting the value in single local array
  for (let i = 0; i < objective.length; i += 1) {
    const tempObjectiveArray = getFlatObjective(objective[i]);
    flatObjectiveArray.push(...tempObjectiveArray);
  }

  // modifying the key of array and saving it to global array
  for (let j = 0; j < flatObjectiveArray.length; j += 1) {
    resultArray.push(
      !getIsRestrictedView(flatObjectiveArray[j], visibilitySettings)
        ? returnObjective(flatObjectiveArray[j], flatObjectiveArray)
        : restrictedObjective
    );
  }

  // implementation to create the blob in .csv file
  const json2csvParser = new Parser({ csvHeaders });

  if (resultArray) {
    const csv = json2csvParser.parse(resultArray);
    // creating the dynamic file name

    downloadCSVFile(csv, filename, 'text/plain');
  }
};

const exportObjectivesUtil = {
  exportObjective: (objective, hideObjective, filename) =>
    exportObjective(objective, hideObjective, filename),

  getFlatObjective: objective => getFlatObjective(objective),

  getCompanyLabel: (isRoot, isCompany, isCompanyChain) =>
    getCompanyLabel(isRoot, isCompany, isCompanyChain),

  getObjectiveTitle: (objectiveId, resultArray) =>
    getObjectiveTitle(objectiveId, resultArray),

  returnObjective: (objective, resultArray) =>
    returnObjective(objective, resultArray)
};

export default exportObjectivesUtil;
